import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from '@mui/material';
import {
  Home as HomeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Event as EventIcon,
  X as XIcon,
  LinkedIn as LinkedInIcon,
} from '@mui/icons-material';
import { MarketingAnalytics } from '../utils/analytics';
import marketingTheme from '../themes/marketingTheme';

const Footer = () => {

  // Get year string
  const currentYear = new Date().getFullYear();

  const handleBookConsult = () => {
    MarketingAnalytics.consultationBooking();
    console.log('booking modal');
    // TODO: Implement booking modal
  };

  const handleEmailClick = () => {
    MarketingAnalytics.socialClick('email');
    console.log('Email link, footer');
  };

  const handleLinkedInClick = () => {
    MarketingAnalytics.socialClick('linkedin');
    console.log('LinkedIn link, footer');
  };

  const ContactItem = ({ icon, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box sx={{ mr: 2, mt: 0.5, color: marketingTheme.palette.primary.main }}>
        {icon}
      </Box>
      <Box>{children}</Box>
    </Box>
  );

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a1a1f',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        py: 6,
        mt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Typography variant="h5" sx={{ mb: 3, color: marketingTheme.palette.primary.main }}>
              Contact Information
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <ContactItem icon={<HomeIcon />}>
                  <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                    PO Box 460<br />
                    Rutherford NSW 2320, Australia
                  </Typography>
                </ContactItem>

                <ContactItem icon={<PhoneIcon />}>
                  <Link
                    href="tel:1300-220-225"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      '&:hover': { color: marketingTheme.palette.primary.main },
                    }}
                  >
                    1300 220 225
                  </Link>
                </ContactItem>
              </Grid>

              <Grid item xs={12} sm={6}>
                <ContactItem icon={<EmailIcon />}>
                  <Link
                    href="mailto:sales@motionlogic.io"
                    onClick={handleEmailClick}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      '&:hover': { color: marketingTheme.palette.primary.main },
                    }}
                  >
                    sales@motionlogic.io
                  </Link>
                </ContactItem>

                <ContactItem icon={<EventIcon />}>
                  <Link
                    component="button"
                    onClick={handleBookConsult}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      p: 0,
                      '&:hover': { color: marketingTheme.palette.primary.main },
                    }}
                  >
                    Book a Consult
                  </Link>
                </ContactItem>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h5" sx={{ mb: 3, color: marketingTheme.palette.primary.main }}>
              Follow Us
            </Typography>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <IconButton
                component={Link}
                href="https://x.com/traversalLabs"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  '&:hover': { color: marketingTheme.palette.primary.main },
                }}
              >
                <XIcon />
              </IconButton>
              
              <IconButton
                component={Link}
                href="https://linkedin.com/company/traversalrobotics"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkedInClick}
                sx={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  '&:hover': { color: marketingTheme.palette.primary.main },
                }}
              >
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            pt: 3,
            mt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            © {currentYear} MotionLogic Pty Ltd. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
